import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const Mathmatics = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },

    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-math.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Facilities"
                breadEnd="Learning Approach"
                breadMid="Math Lab"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <h4 className="color-red">Mathematics</h4>
              <div class="lab-heading mb-4">
                <div class="lab-btn" id="mb-lab-btn">
                  <span>Labs</span>
                </div>
                <ul class="labs-list">
                  <li>
                    <a class="inc-tlink-active" href="/mathmatics">
                      Mathematics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/physics">
                      Physics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/biology">
                      Biology
                    </a>
                  </li>
                  <li>
                    <a class="" href="/chemistry">
                      Chemistry
                    </a>
                  </li>
                  <li>
                    <a class="" href="/language">
                      Language
                    </a>
                  </li>
                  <li>
                    <a class="" href="/computer">
                      Computer
                    </a>
                  </li>
                  <li>
                    <a class="" href="/robotics">
                      Robotics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/hands-on-studio">
                      Hands On Studio
                    </a>
                  </li>
                  <li>
                    <a class="" href="/psychology">
                      Psychology
                    </a>
                  </li>
                  <li>
                    <a class="" href="/counseling-sen">
                      Counseling &amp; Sen{" "}
                    </a>
                  </li>
                </ul>
              </div>
              <h6 className="text-center color-red mb-4">
                <i>
                  “The only way to learn Mathematics is to do Mathematics” –
                  Paul Halmos
                </i>
              </h6>
              <p>
                At Lotus Valley International School, Gurgaon, we believe that
                teaching of Mathematics goes beyond just the transfer of
                knowledge from books to the mind of the learners. Math
                Laboratory or the Math Lab can act like a conduit between
                teacher and learners and provides an opportunity to understand
                and discover the beauty, importance and relevance of Mathematics
                as a discipline.
              </p>
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/math.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                Our exceptionally equipped Math lab comprising of mathematical
                models, teaching kits and a pleasant ambience helps learners
                visualize, manipulate and reason. It creates a context for
                students to attempt their conjectures. The lab offers state of
                the art equipment like Geo board, solid shapes, geometry box,
                clinometer, 3-D shapes etc which help the learners to do hand on
                activities. There are many topics that require visualization
                especially 3D and solid shapes (polyhedra) and the lab helps
                learners to assimilate and understand in-depth concepts.
                Integration of technology with Math is an upcoming ideology to
                enhance the interest of learners using software like Desmos, an
                online calculator and learners have also integrated technology
                with education creating robotics models.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Mathmatics;
